import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const VARIANTS = {
  neutral: "bg-white border border-[#DCE0E7] text-[#626061] hover:text-[#090808] hover:border-[#090808]",
  danger: "bg-white border border-[#FFB3BF] text-[#CE6968] hover:bg-[#FDE7E9]",
  success: "bg-[#D8EEDF] border border-transparent text-[#3f7a52] hover:bg-[#c9e8d3]",
  whatsapp: "bg-[#25D366]/15 border border-transparent text-[#128C4A] hover:bg-[#25D366]/25",
  primary: "bg-[#090808] border border-transparent text-white hover:bg-black shadow-[0_6px_16px_rgba(9,8,8,0.25)]",
  info: "bg-[#E5EEFA] border border-transparent text-[#3B4A63] hover:bg-[#D3E1F5]",
};

const SIZES = { md: "w-10 h-10", sm: "w-9 h-9" };

/** Circular icon-only action button with hover tooltip — used in modal footers. */
export default function IconAction({
  icon: Icon, label, onClick, variant = "neutral", size = "md",
  disabled = false, testid, type = "button",
}) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type={type} onClick={onClick} disabled={disabled} data-testid={testid} aria-label={label}
            className={`${SIZES[size]} rounded-full inline-flex items-center justify-center transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-50 disabled:hover:translate-y-0 ${VARIANTS[variant]}`}
          >
            <Icon className={size === "sm" ? "w-4 h-4" : "w-[18px] h-[18px]"} />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="text-[11px] font-semibold">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
